// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"293":"component---src-pages-index-js","869":"styles"}[chunkId] + "-" + {"293":"b317622950afd9917476","869":"fd2998e0897d497b89f1"}[chunkId] + ".js";
};